import React, { useEffect } from 'react'
import Event from './eventImg/event-8-aug.webp'


const Event17 = () => {
    useEffect(() => {
        document.title = "Distinguished Lecture on Field Measurements & Data Storage in HVAC";
      }, []);
  return (
    <>
    <div className='eventheading'>

<h1  className='text-center'>8 August 2025</h1> 
<h3 className='text-center'>Distinguished Lecture on Field Measurements & Data Storage in HVAC</h3>
</div>
   <div className='container' id='calanderevent'>
<img src={Event} alt='Distinguished Lecture on Field Measurements & Data Storage in HVAC'/>
<button className='mb-4'><a href='https://ishraehq.in/Admin/CalenderEventMaster/Registration_new/46DI4Zfw900=' target='_blank'>Register Now </a></button>
    </div>
    </>
  )
}

export default Event17

